import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { OptionRadioElement } from 'admin/views/site-designer/modules/sections/components/Option';
import {
   SELECTED_ITEM_COLLECTION_VALUE,
   ALL_COLLECTION_VALUE,
   getResourceApiType,
} from 'admin/views/site-designer/modules/content-data';
import cx from 'classnames';
import Icon from 'common/components/elements/icons';
import SelectLibrary from 'admin/views/site-designer/modules/sections/select-library';
import { getCountState } from 'common/utils/utils'
import { createPortal } from 'react-dom';
import { Tooltip } from 'react-tooltip';
import CheckboxLabel from 'common/components/elements/inputs/checkbox-label';
import { fetchResources, initCategories, getProductCountsByType } from 'admin/api/AuthApi';
import CircleLoader from 'common/components/elements/loader/circle';
import RadioLabel from 'common/components/elements/inputs/radio-label';
import { STORE_TYPES } from 'common/designer-modules/siteDesigner';


const ContentCollectionsOptionSection = ({
   options,
   value,
   onChange,
   name,
   contentType,
}) => {
   const [reservState, setReservState] = useState({
      [value.type]: value,
   });

   const type = contentType.replace('_', ' ');
   const [resourceOptions, setResourceOptions] = useState();

   useEffect(() => {
      setResourceOptions();
      setReservState({
         [value.type]: value,
      })
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [contentType])


   return (
      <div className='flex flex-col py-1 bg-panel'>
         {
            options.map((option, index) => {
               const selectedType = value?.type;
               const count = value?.count || 0;
               const checked = selectedType === option.value;
               return (
                  <>
                     <OptionRadioElement
                        key={ index.toString() }
                        option={ option }
                        checked={ checked }
                        onChange={ () => {
                           let data = {
                              type: option.value,
                              ids: [],
                              count: 0,
                           }
                           if(reservState?.[option.value]){
                              data = {
                                 ...reservState[option.value],
                              }
                           }
                           onChange(name, data)
                        } }
                     />
                     {
                        checked  && ALL_COLLECTION_VALUE !== selectedType && (
                           <div className='pr-4 pl-12 pb-[6px] bg-hover flex justify-start'>
                              <div
                                 className={ cx({
                                    'gap-[6px] flex-col items-end': true,
                                    'flex w-full': SELECTED_ITEM_COLLECTION_VALUE !== selectedType,
                                    'inline-flex': SELECTED_ITEM_COLLECTION_VALUE === selectedType,
                                 }) }
                              >
                                 {
                                    SELECTED_ITEM_COLLECTION_VALUE === selectedType && (
                                       <SelectContentById
                                          contentType={ type }
                                          onClickAdd={ ids => {
                                             let data = {
                                                type: selectedType,
                                                ids: ids,
                                                count: ids.length,
                                             }
                                             onChange(name, data)
                                             setReservState({
                                                ...reservState,
                                                [value.type]: data,
                                             })
                                          } }
                                          selections={ value?.ids || {} }
                                       />
                                    )
                                 }
                                 {
                                    SELECTED_ITEM_COLLECTION_VALUE !== selectedType && (
                                       <SelectContentByResource
                                          contentType={ type }
                                          resourceType={ selectedType }
                                          setResourceOptions={ setResourceOptions }
                                          resourceOptions={ resourceOptions }
                                          onClickAdd={ (ids, count) => {

                                             let data = {
                                                type: selectedType,
                                                ids: ids,
                                                count: count,
                                             }
                                             onChange(name, data)
                                             setReservState({
                                                ...reservState,
                                                [value.type]: data,
                                             })
                                          } }
                                          selections={ value?.ids || {} }
                                       />
                                    )
                                 }
                                 <span className=' text-secondary text-xs leading-[15px] text-end'>
                                    {getCountState(count, type)} selected
                                 </span>

                              </div>
                           </div>
                        )
                     }
                  </>
               )
            })
         }
      </div>
   )
}


const SelectContentById = ({
   contentType,
   onClickAdd,
   selections,
}) => {
   const [openContentModal, setOpenContentModal] = useState(false);
   return (
      <>
         <Wrapper
            onClick={ () => setOpenContentModal(true) }
            className='inline-flex px-[18px] py-[10px]'>
            <span className='text-major text-base  leading-[20px] font-medium'>Select {contentType.replace('_', ' ')}s</span>
         </Wrapper>
         {
            openContentModal && (
               <SelectLibrary
                  handleCloseOpenModal={ () => setOpenContentModal(false) }
                  type={  contentType === 'story' ? 'stories' : contentType  }
                  onClickAdd={ onClickAdd }
                  selections={ selections?.reduce((acc, it) =>  [...acc, { id: it, type: contentType === 'story' ? 'stories' : contentType }], []) }
               />
            )
         }
      </>
   )
}
const SelectContentByResource = ({
   contentType,
   resourceType,
   resourceOptions,
   setResourceOptions,
   onClickAdd,
   selections,
}) => {
   const [isOpenSelect, setIsOpenSelect] = useState(false);
   const [isFetching, setIsFetching] = useState(false);

   const { resourceApiType, contentApiType, icon } = getResourceApiType(resourceType, contentType);

   const fetchData = async () => {
      setIsFetching(true);
      try {
         let apis = [];
         if('store_categories' === resourceApiType){
            apis = [initCategories(['count=all'])]
         } else if('store_types' === resourceApiType){
            apis = [getProductCountsByType()];
         } else if(resourceApiType){
            apis = [fetchResources(contentApiType, [`resources=${ resourceApiType }`, 'withCount=videos'])];
         }
         if(apis?.length){
            const [dataApiResposne] = await Promise.all(apis);
            let data = dataApiResposne?.data;
            if(!['store_categories', 'store_types'].includes(resourceApiType)){
               data = data?.[resourceApiType];
            }
            if('store_types' === resourceApiType){
               data = [...STORE_TYPES].map(item => {
                  let { ...elm } = item
                  elm.count = dataApiResposne?.data[item.id]
                  return elm;
               })
            }
            setResourceOptions({ ...resourceOptions, [resourceApiType]: data });
            setIsFetching(false);
         }
      } catch (error) {
         setIsFetching(false);
      }
   }

   const tooltipId = `site_design_${ contentType }_collection_by_${ resourceType }`;
   const options = resourceOptions?.[resourceApiType];
   return (
      <>
         <OptionSelect
            tooltipId={ tooltipId }
            onClick={ () => {
               setIsOpenSelect(!isOpenSelect)
               if(!options){
                  fetchData();
               }
            } }
            mainIcon={ icon }
            selectText={ `Select ${ resourceType }s` }
            isOpenSelect={ isOpenSelect }
            isFetching={ isFetching }
            options={ options }
            activeValue={ { value: selections, name: selections.length ? `${ selections.length } selected` : null } }
            isMultiple={ true }
            onChange={ ids => {
               const count =  options.reduce((acc, current) => {
                  let count = current.count || current.items_in_collection || 0;
                  if(ids.includes(current.id)){
                     acc = acc + count;
                  }
                  return acc
               }, 0)
               onClickAdd(ids, count)
            } }
         />
      </>
   )
}

const Wrapper = ({
   children,
   className = '',
   onClick = () => {},
   ...rest
}) => {
   return (
      <div
         { ...rest }
         role='presentation'
         onClick={ onClick }
         className={ ` border border-divider rounded-lg bg-panel cursor-pointer ${ className }` }>
         {children}
      </div>
   )
}

const OptionSelect = ({
   tooltipId,
   onClick,
   mainIcon,
   selectText,
   isOpenSelect,
   isFetching,
   options,
   isMultiple,
   onChange,
   width = '245px',
   activeValue,
   valueKey = 'id',
}) => {
   return (
      <>
         <Wrapper
            data-tooltip-id={  tooltipId }
            onClick={ onClick }
            className='flex w-full justify-between items-center px-4 py-2'>
            <div className='flex gap-1 items-center'>
               {
                  (mainIcon || activeValue?.icon) && (
                     <OptionIcon
                        icon={ mainIcon || activeValue.icon }
                     />
                  )
               }
               <span className='text-major text-base leading-[20px] select-none'>{activeValue?.name || selectText}</span>

            </div>
            <OptionIcon
               icon={ isOpenSelect ? 'arrow-up' : 'arrow-down' }
            />
         </Wrapper>
         {
            createPortal(
               <Tooltip
                  openOnClick
                  variant={ window.site_dark_bg ? 'dark' : 'light' }
                  id={ tooltipId }
                  place='bottom'
                  clickable
                  isOpen={ isOpenSelect }
                  noArrow
                  style={ {
                     width: width,
                  } }
                  offset='4'
                  className={ cx({
                     'max-h-[240px] shadow dark:shadow-dark border dark:border-divider-dark border-divider overflow-y-auto ams-custom-scrool': true,
                  }) }
               >
                  <div
                     className={ cx({
                        'flex flex-col py-1 w-full': true,
                        'h-[200px] flex items-center justify-center': isFetching || (!isFetching && !options?.length),
                     }) }
                  >
                     {
                        isFetching && (
                           <CircleLoader
                              size={ 8 }
                           />
                        )
                     }
                     {
                        !isFetching && (
                           <>
                              {
                                 !Boolean(options?.length) && (
                                    <span className='text-placeholder text-sm'>No result</span>
                                 )
                              }
                              {
                                 Boolean(options?.length) && options.map((option, index) => {
                                    const optionId = option?.[valueKey]
                                    if(isMultiple){
                                       const selections = activeValue.value
                                       const checked = selections?.includes(optionId);
                                       return (
                                          <CheckboxLabel
                                             key={ optionId || index.toString() }
                                             name={ `${ tooltipId }_${ optionId }` }
                                             checked={ checked }
                                             onChange={ () => {
                                                let value = [...selections]
                                                if(checked){
                                                   value = [...value].filter(el => el !== optionId);
                                                } else {
                                                   value = [...value, optionId]
                                                }
                                                onChange(value);
                                             } }
                                             className={ cx({
                                                'hover:bg-hover dark:hover:bg-hover-dark gap-2': true,
                                                'bg-hover dark:bg-hover-dark': checked,
                                             }) }
                                          >
                                             <div className='flex gap-2 items-center'>
                                                {option?.screen_name || option?.name  || option?.title} {option.count || option.items_in_collection}
                                             </div>
                                          </CheckboxLabel>
                                       )
                                    }
                                    const checked = activeValue?.value === optionId;
                                    return (
                                       <RadioLabel
                                          key={ optionId || index.toString() }
                                          id={ `${ tooltipId }_${ optionId }` }
                                          checked={ checked }
                                          onChange={ () => {
                                             onChange(option);
                                          } }
                                          className={ cx({
                                             'hover:bg-hover dark:hover:bg-hover-dark gap-2': true,
                                             'bg-hover dark:bg-hover-dark': checked,
                                          }) }
                                       >
                                          <div className='flex gap-2 items-center'>
                                             {
                                                option?.icon && (
                                                   <OptionIcon
                                                      icon={ option.icon }
                                                   />
                                                )
                                             }
                                             {option?.screen_name || option?.name  || option?.title}
                                          </div>
                                       </RadioLabel>
                                    )
                                 })
                              }
                           </>
                        )
                     }
                  </div>
               </Tooltip>
               ,
               document.getElementById('tooltips')
            )
         }
      </>
   )
}

const OptionIcon = ({
   icon,
}) => {
   return (
      <div
         className='h-6 w-6 flex items-center justify-center'>
         <Icon
            name={ icon }
            color='secondary'
            size='xl'
         />
      </div>
   )
}

OptionSelect.propTypes = {
   tooltipId: PropTypes.string,
   selectText: PropTypes.string,
   mainIcon: PropTypes.string,
   width: PropTypes.string,
   onClick: PropTypes.func,
   onChange: PropTypes.func,
   activeValue: PropTypes.object,
   isOpenSelect: PropTypes.bool,
   isFetching: PropTypes.bool,
   isMultiple: PropTypes.bool,
   options: PropTypes.array,
   valueKey: PropTypes.string,
};
SelectContentById.propTypes = {
   onClickAdd: PropTypes.func,
   selections: PropTypes.array,
   contentType: PropTypes.oneOf([
      'video', 'story', 'store', 'record_stream', 'photoset',
   ]),
};
OptionIcon.propTypes = {
   icon: PropTypes.string,
};
Wrapper.propTypes = {
   children: PropTypes.any,
   onClick: PropTypes.func,
   className: PropTypes.string,
};
SelectContentByResource.propTypes = {
   setResourceOptions: PropTypes.func,
   onClickAdd: PropTypes.func,
   selections: PropTypes.array,
   resourceOptions: PropTypes.object,
   contentType: PropTypes.string,
   resourceType: PropTypes.string,
};
ContentCollectionsOptionSection.propTypes = {
   options: PropTypes.array,
   value: PropTypes.any,
   onChange: PropTypes.func,
   name: PropTypes.string,
   contentType: PropTypes.oneOf([
      'video', 'story', 'store', 'record_stream', 'photoset',
   ]),
};

export default ContentCollectionsOptionSection;
export {
   OptionSelect,
};
